export const LADE_AUSWAHLWERTE_KORRESPONDENZ = "ladeAuswahlwerteKorrespondenz";
export const LADE_VERSANDLISTEN = "ladeVersandListen";
export const LADE_KORRESPONDENZ_VORLAGEN = "ladeKorrespondenzVorlagen";
export const LADE_AUSWAHLWERTE_MAIL = "ladeAuswahlwerteMail";
export const LADE_MAIL_VORLAGEN = "ladeMailVorlagen";
export const LADE_AUSWAHLWERTE_NOTIZEN = "ladeAuswahlwerteNotizen";
